// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1Kwbt","selects":"Documents_selects__12YzO"};